// extracted by mini-css-extract-plugin
export var categoryElement = "category-item-module--category-element--Dguys";
export var categoryLink = "category-item-module--category-link--16V-5";